import * as MERCHANT_ACTION from "../../constants/merchantActionsType";

const initialState = {
  merchants: [],
  selectedMerchant: {},
  isLoading: false,
  error: ""
};

export const merchantReducer = (
  state = initialState,
  { data, error, type }
) => {
  switch (type) {
    case MERCHANT_ACTION.FETCH_MERCHANTS:
      return {
        ...state,
        isLoading: true
      };

    case MERCHANT_ACTION.FETCH_MERCHANTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        merchants: data
      };

    case MERCHANT_ACTION.FETCH_MERCHANTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error
      };
    default:
      return state;
  }
};
